import React from 'react';
import PropTypes from 'prop-types';
import Link from 'common/link';
import Icon from 'common/icon';

const navLinkClasses =
    'transition m-0 py-4 inline-block text-sm font-bold text-gray-darker group-hover:text-gray-base cursor-pointer';
const subnavLinkClasses =
    'transition text-sm font-bold block py-3 px-6 text-gray-darker hover:text-gray-darkest hover:bg-gray-lightest';

const MainNav = ({ onSearch }) => (
    <nav className="flex items-center -ml-8 xl:-ml-12">
        <div className="pl-8 xl:pl-12">
            <div className="group relative">
                <p className={navLinkClasses}>
                    For Nonprofits
                    <span className="ml-4 inline-block group-hover:hidden">
                        <Icon icon="chevron-down" type="solid" />
                    </span>
                    <span className="ml-4 hidden group-hover:inline-block">
                        <Icon icon="chevron-up" type="solid" />
                    </span>
                </p>
                <nav className="transition pointer-events-none group-hover:pointer-events-auto opacity-0 group-hover:opacity-100 absolute pin-t pin-l w-64 mt-8 group-hover:mt-12 pt-4">
                    <div className="normal-case tracking-normal bg-white shadow-md rounded-lg overflow-hidden py-3">
                        <Link
                            className={subnavLinkClasses}
                            to="/nonprofits/nonprofit-solutions"
                            legacy
                        >
                            Nonprofit Solutions
                        </Link>
                        <Link
                            className={subnavLinkClasses}
                            to="/nonprofits/peer-to-peer-fundraising"
                            legacy
                        >
                            Peer-to-Peer
                        </Link>
                        <Link
                            className={subnavLinkClasses}
                            to="/nonprofits/events-ticketing"
                            legacy
                        >
                            Events &amp; Ticketing
                        </Link>
                        <Link className={subnavLinkClasses} to="/nonprofits/golf-marathons" legacy>
                            Golf Marathon
                        </Link>
                        <Link className={subnavLinkClasses} to="/nonprofits/run-walk-ride" legacy>
                            Run, Walk, Ride
                        </Link>
                        <Link
                            className={subnavLinkClasses}
                            to="/nonprofits/virtual-hybrid-challenges"
                            legacy
                        >
                            Virtual and Hybrid Challenges
                        </Link>
                        <Link className={subnavLinkClasses} to="/nonprofits/integrations" legacy>
                            Integrations
                        </Link>
                    </div>
                </nav>
            </div>
        </div>
        <div className="pl-8 xl:pl-12">
            <div className="group relative">
                <p className={navLinkClasses}>
                    For Individuals
                    <span className="ml-4 inline-block group-hover:hidden">
                        <Icon icon="chevron-down" type="solid" />
                    </span>
                    <span className="ml-4 hidden group-hover:inline-block">
                        <Icon icon="chevron-up" type="solid" />
                    </span>
                </p>
                <nav className="transition pointer-events-none group-hover:pointer-events-auto opacity-0 group-hover:opacity-100 absolute pin-t pin-l w-64 py-3 mt-8 group-hover:mt-12 pt-4">
                    <div className="normal-case tracking-normal bg-white shadow-md rounded-lg overflow-hidden py-3">
                        <Link className={subnavLinkClasses} to="/individuals/how-it-works" legacy>
                            How it Works
                        </Link>
                        <Link className={subnavLinkClasses} to="/individuals/product-tour" legacy>
                            Product Tour
                        </Link>
                        <Link
                            className={subnavLinkClasses}
                            to="/individuals/current-campaigns/individuals"
                            legacy
                        >
                            Current Campaigns
                        </Link>
                        <Link className={subnavLinkClasses} to="/individuals/faqs" legacy>
                            FAQs
                        </Link>
                    </div>
                </nav>
            </div>
        </div>
        <div className="pl-8 xl:pl-12">
            <div className="group relative">
                <Link className={navLinkClasses} to="/pricing">
                    Pricing
                </Link>
            </div>
        </div>
        <div className="pl-8 xl:pl-12">
            <div className="group relative">
                <p className={navLinkClasses}>
                    Resources
                    <span className="ml-4 inline-block group-hover:hidden">
                        <Icon icon="chevron-down" type="solid" />
                    </span>
                    <span className="ml-4 hidden group-hover:inline-block">
                        <Icon icon="chevron-up" type="solid" />
                    </span>
                </p>
                <nav className="transition pointer-events-none group-hover:pointer-events-auto opacity-0 group-hover:opacity-100 absolute pin-t pin-l w-64 py-3 mt-8 group-hover:mt-12 pt-4">
                    <div className="normal-case tracking-normal bg-white shadow-md rounded-lg overflow-hidden py-3">
                        <Link className={subnavLinkClasses} to="/blog">
                            Blog
                        </Link>
                        <Link className={subnavLinkClasses} to="/blog/category/press">
                            Press
                        </Link>
                        <Link className={subnavLinkClasses} to="/blog/category/tips-and-guides">
                            Tips &amp; Guides
                        </Link>
                        <Link className={subnavLinkClasses} to="/blog/category/case-studies">
                            Case Studies
                        </Link>
                        <Link className={subnavLinkClasses} to="/blog/category/champions">
                            Champions
                        </Link>
                    </div>
                </nav>
            </div>
        </div>
        <div className="pl-8 xl:pl-12">
            <button type="button" onClick={onSearch} className={navLinkClasses}>
                <Icon icon="search" type="solid" className="mr-4" />
            </button>
        </div>
    </nav>
);

MainNav.propTypes = {
    onSearch: PropTypes.func.isRequired,
};

export default MainNav;
